import { render, staticRenderFns } from "./EventRegistrationForm.vue?vue&type=template&id=8affd9f8&scoped=true&"
import script from "./EventRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./EventRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./EventRegistrationForm.vue?vue&type=style&index=0&id=8affd9f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8affd9f8",
  null
  
)

export default component.exports